import React, { Component } from "react";

import ProjPeopleContent from "../../ProjPeopleContent";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

const projTeam = {
  header: [
    "Deputy Project Director",
    "Principal Investigator",
    "Co-investigators",
    "Team Lead",
    "Team Members",
    "Research Scientists",
    "Research Fellows",
  ],
  rows: {
    row1: [
      "Shri. P.V. Raju Head, WRAD, WRG",
      "Sri. B. Simhadri Rao, S/E 'SG', WRAD, WRG",
      "Sri. Saksham joshi, S/E  'SD', WRAD, WRG",
      "",
      "",
      "Sri. P Gopi  (RS&GIS)",
      "Ms. V Madhavi Supriya SRF (RS&GIS)",
    ],
    //  row2:["", "", "", "", "", "Sri. P Gopi  (RS&GIS)", ""],
  },
};
export default class SProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "100%" }}>
              <div className="card-body">
                <ProjPeopleContent data={projTeam} width="80%" />
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
